<script>
export default {
  render() {
    return (
      <li>
        <hr class={this.$style.root} />
      </li>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  border: solid 1px $--border-color-base;
  margin: 1.5rem 0;
}
</style>
